import { Controller } from "@hotwired/stimulus"

// Консоль раскладки: поле «Лимит времени» имеет смысл только для движка SVGnest,
// показываем/прячем его при переключении radio-карточек Базовая/SVGnest.
export default class extends Controller {
  static targets = ["seconds"]

  toggleSeconds(event) {
    this.secondsTarget.classList.toggle("hidden", event.target.value !== "svgnest")
  }
}
